import { Wrapper } from './style';

// Component
import Container from 'components/common/Layout/Container';
import Image from 'next/image';
import Text from 'components/common/Text';

// Libs
import Translation from 'libs/Translation';

const About = ({ webConfig }) => {

    const items = [
        {id: 0, title: Translation.t('title.why-vclinic'), desc: Translation.t('text.why-desc'), desc1: Translation.t('text.why-desc2'), desc2: Translation.t('text.why-desc3'), desc3: Translation.t('text.why-desc4')},
        {id: 1, title: Translation.t('title.our-services'), desc: Translation.t('text.services-desc')},
    ]

    return (
        <Wrapper webConfig={webConfig}>
            <div className='header'>
                <Container>
                <div className='column-flex'>
                    <Text
                        tag="span"
                        className="main-title"
                    >   
                        {Translation.t('title.about')}
                    </Text>
                    <Text
                        tag="h3"
                        className="desc"
                    >   
                        {Translation.t('text.about-desc')}
                    </Text>
                </div>
                </Container>
            </div>

            <Container>
            {items.map(i => (
                <div 
                    key={i.id}
                    className='card'
                >
                <Text
                    tag="h2"
                    className="title"
                >   
                    {i.title}
                </Text>
                <Text
                    tag="h3"
                    className="subtitle"
                >   
                     {i.desc}
                </Text>
                {i.desc1 &&
                <Text
                  tag="h3"
                  className="subtitle"
                >   
                   {i.desc1}
                </Text>
                }
                {i.desc2 &&
                <Text
                  tag="h3"
                  className="subtitle"
                >   
                   {i.desc2}
                </Text>
                }
                {i.desc3 &&
                <Text
                  tag="h3"
                  className="subtitle"
                >   
                   {i.desc3}
                </Text>
                }
                </div>
            ))}
           </Container>
        </Wrapper>
    )
}

export default About;